import React, { forwardRef, ReactNode, useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import { Input, InputContainer } from "./styles";
import { TextError } from "../../shared/styles/global.styles";

interface InputProps {
  color: string;
  placeholder: string;
  id: string;
  width?: number;
  name?: string;
  border?: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  mask?: string;
  maxLength?: number;
  autoFocus?: boolean;
  min?: string;
  max?: string;
  disabled?: boolean;
  className?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  styled?: boolean;
  style?: React.CSSProperties;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onIconLeftClick?: () => void;
  onIconRightClick?: () => void;
  errorMessage?: string | boolean;
}

const InputComponent = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      color,
      placeholder,
      id,
      width,
      border,
      name,
      value,
      onChange,
      mask,
      type = "text",
      maxLength,
      autoFocus = false,
      iconLeft,
      iconRight,
      onIconLeftClick,
      onIconRightClick,
      errorMessage,
      className,
      max,
      min,
      disabled,
      style,
      onKeyDown,
      ...props
    },
    ref // A ref é passada automaticamente pelo forwardRef
  ) => {
    // Adicionar classe adicional quando o input for do tipo date
    const [hasValue, setHasValue] = useState(!!value);

    useEffect(() => {
      setHasValue(!!value);
    }, [value]);

    // Determinar as classes a serem aplicadas
    let inputClassName = className || "";

    // Para inputs do tipo date, adicionar classes específicas
    if (type === "date") {
      inputClassName += hasValue ? " date-with-value" : " date-placeholder";
    }

    return (
      <>
        <InputContainer
          width={width}
          hasIconLeft={!!iconLeft}
          hasIconRight={!!iconRight}
          error={!!errorMessage}
        >
          {iconLeft && (
            <span onClick={onIconLeftClick} style={{ cursor: "pointer" }}>
              {iconLeft}
            </span>
          )}
          {mask ? (
            <ReactInputMask
              mask={mask}
              value={value}
              onChange={(e) => {
                if (onChange) {
                  onChange(e);
                }
                if (type === "date") {
                  setHasValue(!!e.target.value);
                }
              }}
              placeholder={placeholder}
              id={id}
              name={name}
              type={type}
              autoFocus={autoFocus}
              maxLength={maxLength}
              inputRef={ref} // Repassa a ref para o ReactInputMask
              className={inputClassName}
              max={max}
              min={min}
              {...props}
            />
          ) : (
            <Input
              error={!!errorMessage}
              color={color}
              placeholder={placeholder}
              name={name}
              id={id}
              type={type}
              value={value}
              maxLength={maxLength}
              onChange={(e) => {
                if (onChange) {
                  onChange(e);
                }
                if (type === "date") {
                  setHasValue(!!e.target.value);
                }
              }}
              autoFocus={autoFocus}
              ref={ref}
              className={inputClassName}
              max={max}
              min={min}
              disabled={disabled}
              {...props}
            />
          )}
          {iconRight && (
            <span onClick={onIconRightClick} style={{ cursor: "pointer" }}>
              {iconRight}
            </span>
          )}
        </InputContainer>
        {errorMessage && <TextError>{errorMessage}</TextError>}
      </>
    );
  }
);

export default InputComponent;
